import { SharedModule } from '@Shared/shared.module';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgFor } from '@angular/common';
export interface MrsDropDownPrimaryItem {
    value: string;
    displayValue: string;
}

@Component({
    selector: 'mrs-dropdown-primary',
    templateUrl: './mrs-dropdown-primary.component.html',
    styleUrls: ['./mrs-dropdown-primary.component.scss'],
    imports: [FormsModule, MatFormField, MatLabel, MatSelect, NgFor, MatOption, SharedModule]
})
export class MrsDropDownPrimaryComponent {
    @Input() selectedValue: string;
    @Input() label: string;
    @Input() values: MrsDropDownPrimaryItem[];
    @Output() selectedValueChange = new EventEmitter<string>();

    constructor(
    ) {
        // consloe.log("test");
        // this.selectedValue = "steak-0";
    }

    updateSelectedValue(event) {
        this.selectedValueChange.emit(event);
    }
}
